/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `ApiKey.ts` file.
 ******/
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

import { ApiKey } from "./ApiKey";

import { Audit } from "./Audit";
import { CommandCenterView } from "./CommandCenterView";
import { Project } from "./Project";
import { User } from "./User";

export type scope = "api" | "dashboard";
export type state = "active" | "inactive" | "deleted";

export const scopeValues = { api: 0, dashboard: 1 };
export const stateValues = { active: 0, inactive: 1, deleted: 2 };

export abstract class ApiKeyModel {
    id: number;
    createdAt: Dayjs;
    key: string;
    projectId: number;
    scope: scope;
    secretKey: string | null;
    state: state;
    updatedAt: Dayjs;
    userId: number;
    audits: Audit[] | undefined;
    commandCenterView: CommandCenterView | null | undefined;
    project: Project | null | undefined;
    user: User | null | undefined;
    _destroy: boolean | undefined;

    constructor(
        id: number,
        createdAt: Dayjs,
        key: string,
        projectId: number,
        scope: scope,
        secretKey: string | null,
        state: state,
        updatedAt: Dayjs,
        userId: number,
        audits: Audit[] | undefined,
        commandCenterView: CommandCenterView | null | undefined,
        project: Project | null | undefined,
        user: User | null | undefined
    ) {
        this.id = id;
        this.createdAt = createdAt;
        this.key = key;
        this.projectId = projectId;
        this.scope = scope;
        this.secretKey = secretKey;
        this.state = state;
        this.updatedAt = updatedAt;
        this.userId = userId;
        this.audits = audits;
        this.commandCenterView = commandCenterView;
        this.project = project;
        this.user = user;
    }

    static fromApiObject(json: any, timezone: string): ApiKey {
        const newObject = new ApiKey(
            json["id"],
            dayjs(json["created_at"]).tz(timezone),
            json["key"],
            json["project_id"],
            json["scope"],
            json["secret_key"],
            json["state"],
            dayjs(json["updated_at"]).tz(timezone),
            json["user_id"],
            json["audits"]?.map((item: any) => Audit.fromApiObject(item, timezone)),
            json["command_center_view"] == null
                ? json["command_center_view"]
                : CommandCenterView.fromApiObject(json["command_center_view"], timezone),
            json["project"] == null ? json["project"] : Project.fromApiObject(json["project"], timezone),
            json["user"] == null ? json["user"] : User.fromApiObject(json["user"], timezone)
        );

        return newObject;
    }

    toApiObject(): any {
        return {
            id: this.id,
            created_at: this.createdAt,
            key: this.key,
            project_id: this.projectId,
            scope: this.scope,
            secret_key: this.secretKey,
            state: this.state,
            updated_at: this.updatedAt,
            user_id: this.userId,
            audits: this.audits?.map((item) => item.toApiObject()),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): ApiKey {
        const clone = Object.create(this) as ApiKey;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
